import { config, animated } from 'react-spring'
import { AspectRatio } from '@/components/Layouts'

export const AnimatedAspectRatio = animated(AspectRatio)

export const DEFAULT_SPRING_CONFIG = config.default
